"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cleanUp(xml) {
    var xmlStart = xml.indexOf('<?xml ');
    return xml.substring(xmlStart).trim();
}
exports.cleanUp = cleanUp;
function parse(xml, parser) {
    if (parser === void 0) { parser = new window.DOMParser(); }
    xml = cleanUp(xml);
    return parser.parseFromString(xml, 'text/xml');
}
exports.parse = parse;
